import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
// import Home1 from './pages/Home1.vue'
const About = () => import( /* webpackChunkName: "About" */ './pages/About.vue')
const Tech = () => import( /* webpackChunkName: "About" */ './pages/Tech.vue')
const TechAdvantage = () => import( /* webpackChunkName: "About" */ './pages/TechAdvantage.vue')
const Products = () => import( /* webpackChunkName: "About" */ './pages/Products.vue')
const ProductsServer = () => import( /* webpackChunkName: "About" */ './pages/ProductsServer.vue')
const ProductsDisplay = () => import( /* webpackChunkName: "About" */ './pages/ProductsDisplay.vue')
const ProductsEquipment = () => import( /* webpackChunkName: "About" */ './pages/ProductsEquipment.vue')
const Subsidiary = () => import( /* webpackChunkName: "About" */ './pages/Subsidiary.vue')
const SubsidiaryServer = () => import( /* webpackChunkName: "About" */ './pages/SubsidiaryServer.vue')
const SubsidiaryDisplay = () => import( /* webpackChunkName: "About" */ './pages/SubsidiaryDisplay.vue')
const SubsidiaryEquipment = () => import( /* webpackChunkName: "About" */ './pages/SubsidiaryEquipment.vue')
const SubsidiaryCharacteristics = () => import( /* webpackChunkName: "About" */ './pages/SubsidiaryCharacteristics.vue')
const SubsidiaryHonor = () => import( /* webpackChunkName: "About" */ './pages/SubsidiaryHonor.vue')
const News = () => import( /* webpackChunkName: "About" */ './pages/News.vue')
const NewsList = () => import( /* webpackChunkName: "About" */ './pages/NewsList.vue')
const NewsDetail = () => import( /* webpackChunkName: "About" */ './pages/NewsDetail.vue')
const Hr = () => import( /* webpackChunkName: "About" */ './pages/Hr.vue')
const HrCompany = () => import( /* webpackChunkName: "About" */ './pages/HrCompany.vue')
const HrRecruit = () => import( /* webpackChunkName: "About" */ './pages/HrRecruit.vue')
const InternalVideo = () => import( /* webpackChunkName: "About" */ './pages/InternalVideo.vue')
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Home,
    },
    {
      path: '/home',
      component: Home,
    },
    {
      path: '/building',
      component: () => import( /* webpackChunkName: "About" */ './pages/building.vue'),
    },
    {
      path: '/about/:id?',
      component: About
    },
    {
      path: '/tech',
      component: Tech,
      children: [{
          path: "advantage/:id?",
          component: TechAdvantage,
          alias: "/tech"
        }
      ]
    },
    {
      path: "/products",
      component: Products,
      children: [{
        path: "server",
        component: ProductsServer,
        alias: "/products"
      },
      {
        path: "display",
        component: ProductsDisplay
      },
      {
        path: "equipment",
        component: ProductsEquipment
      }
    ]
    },
    {
      path: "/subsidiary",
      component: Subsidiary,
      children: [{
        path: "server/:id",
        component: SubsidiaryServer
      },
      {
        path: "display/:id",
        component: SubsidiaryDisplay
      },
      {
        path: "equipment/:id",
        component: SubsidiaryEquipment
      },
      {
        path: "characteristic/:id?",
        component: SubsidiaryCharacteristics,
        // alias: "/subsidiary/:id"
      },
      {
        path: "honor/:id",
        component: SubsidiaryHonor
      },
    ]
    },
    {
      path: "/news",
      component: News,
      children: [{
          path: "list",
          component: NewsList,
          alias: "/news"
        },
        {
          path: "newsDetail/:id",
          component: NewsDetail
        }
      ]
    },
    {
      path: "/hr",
      component: Hr,
      children: [{
        path: "company",
        component: HrCompany,
        alias: "/hr"
      },
      {
        path: "recruit",
        component: HrRecruit
      }
    ]
    },
    {
      path: "/video",
      component: InternalVideo,
    },
    {
      path: "/sz",
      redirect: "/subsidiary/characteristic/4",
    },
    {
      path: "/guangzhou",
      redirect: "/subsidiary/characteristic/2",
    },
    {
      path: "/qd",
      redirect: "/subsidiary/characteristic/3",
    },
    {
      path: "/gz",
      redirect: "/subsidiary/characteristic/5",
    },
    {
      path: "/xian",
      redirect: "/subsidiary/characteristic/6",
    },
    {
      path: "/hb",
      redirect: "/subsidiary/characteristic/7",
    },
    {
      path: "/ym",
      redirect: "/subsidiary/characteristic/8",
    },
    {
      path: "/hhx",
      redirect: "/subsidiary/characteristic/9",
    }
  ]
})